import { Mesh, Vector3, Box3 } from "three";

import { isBJ } from "./Scene";
import {
  getToothTotalIPR,
  moveToothDistally,
  moveToothMesially,
  endChunckMovement,
  setIsMultipleTeethMovement,
  setStopAutoSave,
  undoMovementList,
  toothMovementAmount,
  setToothMovementAmount,
} from "./teethControls/TeethPositionHelper";
import { iprOverLays as iprOverlaysGlobalCopy } from "@/helpers/ipr";
import { undoRef as undo } from "./teethControls/URR";

export let isAutoAdjustOn = false;
export let isAutoAdjustResultMovement = false;
let currentMovingTeethKey;
const teethMovementGroups = {
  t1: {},
  t2: {},
  t3: { t2: true, t4: true, t5: true },
  t4: {},
  t5: { t4: true },
  t6: {
    t4: true,
    t5: true,
    t7: true,
  },
  t7: {},
  t8: { t7: true },
  t9: { t10: true },
  t10: {},
  t11: { t10: true, t12: true, t13: true },
  t12: { t13: true },
  t13: {},
  t14: { t12: true, t13: true, t15: true },
  t15: {},
  t16: {},
  t17: {},
  t18: {},
  t19: { t18: true, t20: true, t21: true },
  t20: {},
  t21: { t20: true },
  t22: { t20: true, t21: true, t23: true },
  t23: {},
  t24: { t23: true },
  t25: { t26: true },
  t26: {},
  t27: { t26: true, t28: true, t29: true },
  t28: { t29: true },
  t29: {},
  t30: { t28: true, t29: true, t31: true },
  t31: {},
  t32: {},
};

/**
 *
 * @param {Boolean} state
 */
export function setIsAutoAdjustOn(state) {
  isAutoAdjustOn = state;
}
let saftyVar = 0;
let firstCall = false;
const AAIPRLimit = 0.47;
export function call3DControls(
  selectedTooth,
  logs,
  iprOverLays,
  setLogs,
  setIprOverlays,
  setAutoSave,
  call,
  newAAIPRLimit = 0,
) {
  const startUndoMovementListLength = undoMovementList.length;

  //#region selected tooth movement
  const localFirstCall = !firstCall;
  firstCall = true;
  saftyVar++;
  if (saftyVar > 16) {
    console.log("exit");
    return;
  }
  setStopAutoSave(true);
  setIsMultipleTeethMovement(true);

  const selectedToothInfo = selectedTooth.name.split("_");
  const isLower = selectedToothInfo[0] === "l";
  const stepNumber = +parseInt(selectedToothInfo[1].substr(2, 4));
  const selectedToothKey = selectedToothInfo[2];

  const selectedToothIndex =
    selectedTooth.parent.children.indexOf(selectedTooth);

  const nextToothIndex = selectedToothIndex + (isLower ? -1 : 1),
    previousToothIndex = selectedToothIndex + (isLower ? 1 : -1);

  let selectedToothIprIndex;
  if (selectedToothIndex > -1) {
    selectedToothIprIndex = iprOverlaysGlobalCopy[isLower ? 1 : 0][
      selectedToothKey
    ].findIndex(element => {
      return element.step == stepNumber;
    });
  }

  let previousToothKey, previousToothIprIndex;
  if (
    previousToothIndex > -1 &&
    previousToothIndex < selectedTooth.parent.children.length
  ) {
    previousToothKey =
      selectedTooth.parent.children[previousToothIndex].name.split("_")[2];
    previousToothIprIndex = iprOverlaysGlobalCopy[isLower ? 1 : 0][
      previousToothKey
    ].findIndex(element => {
      return element.step == stepNumber;
    });
  }

  let oldToothIPR =
    iprOverlaysGlobalCopy[isLower ? 1 : 0][selectedToothKey][
      selectedToothIprIndex
    ]?.amount;
  oldToothIPR = oldToothIPR ? oldToothIPR : 0;

  let oldPreviousToothIPR = previousToothKey
    ? iprOverlaysGlobalCopy[isLower ? 1 : 0][previousToothKey][
        previousToothIprIndex
      ]?.amount
    : 0;
  oldPreviousToothIPR = oldPreviousToothIPR ? oldPreviousToothIPR : 0;
  let isAllowedMovement = call(
    selectedTooth,
    logs,
    iprOverLays,
    setLogs,
    setIprOverlays,
    setAutoSave,
  );
  isAutoAdjustResultMovement = true;
  if (selectedToothIndex > -1) {
    selectedToothIprIndex = iprOverlaysGlobalCopy[isLower ? 1 : 0][
      selectedToothKey
    ].findIndex(element => {
      return element.step == stepNumber;
    });
  }
  if (
    previousToothIndex > -1 &&
    previousToothIndex < selectedTooth.parent.children.length
  ) {
    previousToothIprIndex = iprOverlaysGlobalCopy[isLower ? 1 : 0][
      previousToothKey
    ].findIndex(element => {
      return element.step == stepNumber;
    });
  }
  let newToothIPR =
    iprOverlaysGlobalCopy[isLower ? 1 : 0][selectedToothKey][
      selectedToothIprIndex
    ]?.amount;
  newToothIPR = newToothIPR ? newToothIPR : 0;
  let newTotalIPR = getToothTotalIPR(
    isLower ? 1 : 0,
    selectedToothKey,
    iprOverlaysGlobalCopy,
    false,
  );

  let newPreviousToothIPR = previousToothKey
    ? iprOverlaysGlobalCopy[isLower ? 1 : 0][previousToothKey][
        previousToothIprIndex
      ]?.amount
    : 0;
  newPreviousToothIPR = newPreviousToothIPR ? newPreviousToothIPR : 0;

  let newPreviousToothTotalIPR = previousToothKey
    ? getToothTotalIPR(
        isLower ? 1 : 0,
        previousToothKey,
        iprOverlaysGlobalCopy,
        false,
      )
    : undefined;

  //#endregion

  //#region pushing teeth
  let isNextMovementAllowed = isAllowedMovement;
  let movementDirection;
  let pulledTooth;

  if (isAllowedMovement) {
    currentMovingTeethKey = selectedToothKey;
    if (
      oldToothIPR <= newToothIPR &&
      newTotalIPR > newAAIPRLimit &&
      isNextMovementAllowed
    ) {
      if (
        nextToothIndex >= 0 &&
        nextToothIndex < selectedTooth.parent.children.length
      ) {
        movementDirection = isLower ? -1 : 1;
        const oldToothMovementIPR = toothMovementAmount;
        setToothMovementAmount(newToothIPR - oldToothIPR + 0.05);
        isNextMovementAllowed = pushTeeth(
          selectedTooth,
          movementDirection,
          logs,
          setLogs,
          setIprOverlays,
          setAutoSave,
          newAAIPRLimit,
        );
        setToothMovementAmount(oldToothMovementIPR);

        pulledTooth = selectedTooth.parent.children[previousToothIndex];
      }
    }
    if (
      oldPreviousToothIPR <= newPreviousToothIPR &&
      newPreviousToothTotalIPR > newAAIPRLimit &&
      isNextMovementAllowed
    ) {
      if (
        previousToothIndex >= 0 &&
        previousToothIndex < selectedTooth.parent.children.length
      ) {
        movementDirection = isLower ? 1 : -1;
        const oldToothMovementIPR = toothMovementAmount;
        setToothMovementAmount(
          newPreviousToothIPR - oldPreviousToothIPR + 0.05,
        );
        isNextMovementAllowed = pushTeeth(
          selectedTooth,
          movementDirection,
          logs,
          setLogs,
          setIprOverlays,
          setAutoSave,
          newAAIPRLimit,
        );
        setToothMovementAmount(oldToothMovementIPR);

        pulledTooth = selectedTooth;
      } else {
      }
    }
    //#endregion

    //#region pulling teeth
    if (oldToothIPR > newToothIPR && newTotalIPR < 0 && isNextMovementAllowed) {
      if (
        nextToothIndex >= 0 &&
        nextToothIndex < selectedTooth.parent.children.length
      ) {
        movementDirection = isLower ? -1 : 1;
        const oldToothMovementIPR = toothMovementAmount;
        setToothMovementAmount(oldToothIPR - newToothIPR);
        isNextMovementAllowed = pullTeeth(
          selectedTooth,
          movementDirection,
          logs,
          setLogs,
          setIprOverlays,
          setAutoSave,
        );
        setToothMovementAmount(oldToothMovementIPR);
      }
    }
    if (
      oldPreviousToothIPR > newPreviousToothIPR &&
      newPreviousToothTotalIPR < 0 &&
      isNextMovementAllowed
    ) {
      if (
        previousToothIndex >= 0 &&
        previousToothIndex < selectedTooth.parent.children.length
      ) {
        movementDirection = isLower ? 1 : -1;
        const oldToothMovementIPR = toothMovementAmount;
        setToothMovementAmount(oldPreviousToothIPR - newPreviousToothIPR);
        isNextMovementAllowed = pullTeeth(
          selectedTooth,
          movementDirection,
          logs,
          setLogs,
          setIprOverlays,
          setAutoSave,
        );
        setToothMovementAmount(oldToothMovementIPR);
      }
    }
    //#endregion

    // if (isPullingAllowed && pulledTooth) {
    //   //#region pulling teeth
    //   if (
    //     getToothTotalIPR(
    //       isLower ? 1 : 0,
    //       pulledTooth.name.split("_")[2],
    //       iprOverlaysGlobalCopy,
    //       false,
    //     ) < 0
    //   ) {
    //     pullTeeth(
    //       selectedTooth,
    //       movementDirection,
    //       logs,
    //       setLogs,
    //       setIprOverlays,
    //       setAutoSave,
    //     );
    //   }

    //   //#endregion
    // } else

    // console.log(iprOverLays[0][toothKey][iprIndex]);
    saftyVar = 0;
    currentMovingTeethKey = undefined;

    setIprOverlays(iprOverlaysGlobalCopy);
    setStopAutoSave(false);
    setAutoSave();
    setIsMultipleTeethMovement(false);

    if (!isNextMovementAllowed) {
      undo(false);
      if (newAAIPRLimit !== AAIPRLimit) {
        isAutoAdjustResultMovement = false;
        call3DControls(
          selectedTooth,
          logs,
          iprOverLays,
          setLogs,
          setIprOverlays,
          setAutoSave,
          call,
          AAIPRLimit,
        );
      }
    } else {
      endChunckMovement();
    }
    isAutoAdjustResultMovement = false;

    return isAllowedMovement;
  }
}

export function pushTeeth(
  selectedTooth,
  movementIndex,
  logs,
  setLogs,
  setIprOverlays,
  setAutoSave,
  newAAIPRLimit,
) {
  let isAllowedMovement = true;
  let didCreateSpace = false;
  let isLower = selectedTooth.name.charAt(0) === "l";
  let oldTotalToothIPR;
  let secondTooth, thirdTooth;
  while (isAllowedMovement) {
    saftyVar++;
    if (saftyVar > 16) {
      console.log("exit");
      return false;
    }
    const secondToothIndex =
      selectedTooth.parent.children.indexOf(selectedTooth) + movementIndex;
    secondTooth = selectedTooth.parent.children[secondToothIndex];

    thirdTooth =
      selectedTooth.parent.children[secondToothIndex + movementIndex];

    if (!secondTooth) {
      console.log("exit");
      break;
    }
    if (
      !teethMovementGroups[currentMovingTeethKey][
        secondTooth.name.split("_")[2]
      ]
    ) {
      break;
    }
    if (thirdTooth) {
      oldTotalToothIPR = getToothTotalIPR(
        isLower ? 1 : 0,
        isLower
          ? movementIndex < 0
            ? secondTooth.name.split("_")[2]
            : thirdTooth.name.split("_")[2]
          : movementIndex > 0
            ? secondTooth.name.split("_")[2]
            : thirdTooth.name.split("_")[2],
        iprOverlaysGlobalCopy,
        false,
      );
    } else {
      oldTotalToothIPR = -Infinity;
    }

    isAllowedMovement = pushFirstAwayFromSecond(secondTooth, selectedTooth)(
      secondTooth,
      logs,
      iprOverlaysGlobalCopy,
      setLogs,
      setIprOverlays,
      setAutoSave,
    );
    didCreateSpace = true;
    selectedTooth = secondTooth;
    if (oldTotalToothIPR < newAAIPRLimit) {
      isAllowedMovement = true;
      break;
    }
  }
  if (didCreateSpace) {
    const newToothTotalIPR = getToothTotalIPR(
      isLower ? 1 : 0,
      isLower
        ? movementIndex < 0
          ? selectedTooth.name.split("_")[2]
          : secondTooth.name.split("_")[2]
        : movementIndex > 0
          ? selectedTooth.name.split("_")[2]
          : secondTooth.name.split("_")[2],
      iprOverlaysGlobalCopy,
      false,
    );

    if (
      oldTotalToothIPR >= newAAIPRLimit &&
      newToothTotalIPR > newAAIPRLimit &&
      oldTotalToothIPR < newToothTotalIPR
    ) {
      console.log("false now");

      isAllowedMovement = false;
    }
  }

  return isAllowedMovement && didCreateSpace;
}

export function pullTeeth(
  selectedTooth,
  movementIndex,
  logs,
  setLogs,
  setIprOverlays,
  setAutoSave,
) {
  let isAllowedMovement = true;
  let didCreateSpace = false;
  let oldTotalToothIPR;
  let isLower = selectedTooth.name.charAt(0) === "l";
  let secondTooth, thirdTooth;
  while (isAllowedMovement) {
    saftyVar++;
    if (saftyVar > 16) {
      console.log("exit");
      return false;
    }
    const secondToothIndex =
      selectedTooth.parent.children.indexOf(selectedTooth) + movementIndex;
    secondTooth = selectedTooth.parent.children[secondToothIndex];

    thirdTooth =
      selectedTooth.parent.children[secondToothIndex + movementIndex];

    if (!secondTooth) {
      console.log("exit");
      break;
    }
    if (
      !teethMovementGroups[currentMovingTeethKey][
        secondTooth.name.split("_")[2]
      ]
    ) {
      break;
    }
    if (thirdTooth) {
      oldTotalToothIPR = getToothTotalIPR(
        isLower ? 1 : 0,
        isLower
          ? movementIndex < 0
            ? secondTooth.name.split("_")[2]
            : thirdTooth.name.split("_")[2]
          : movementIndex > 0
            ? secondTooth.name.split("_")[2]
            : thirdTooth.name.split("_")[2],
        iprOverlaysGlobalCopy,
        false,
      );
    } else {
      oldTotalToothIPR = Infinity;
    }

    isAllowedMovement = pullFirstCloserFromSecond(secondTooth, selectedTooth)(
      secondTooth,
      logs,
      iprOverlaysGlobalCopy,
      setLogs,
      setIprOverlays,
      setAutoSave,
    );

    didCreateSpace = true;
    selectedTooth = secondTooth;
    if (oldTotalToothIPR > 0) {
      isAllowedMovement = true;
      break;
    }
  }

  if (didCreateSpace) {
    const newToothTotalIPR = getToothTotalIPR(
      isLower ? 1 : 0,
      isLower
        ? movementIndex < 0
          ? selectedTooth.name.split("_")[2]
          : secondTooth.name.split("_")[2]
        : movementIndex > 0
          ? selectedTooth.name.split("_")[2]
          : secondTooth.name.split("_")[2],
      iprOverlaysGlobalCopy,
      false,
    );

    if (
      oldTotalToothIPR >= 0 &&
      newToothTotalIPR > 0 &&
      oldTotalToothIPR < newToothTotalIPR
    ) {
      console.log("false now");

      isAllowedMovement = false;
    }
  }
  return isAllowedMovement;
}

/**
 *
 * @param {Mesh} firstTooth
 * @param {Mesh} secondTooth
 * @returns
 */
function pushFirstAwayFromSecond(firstTooth, secondTooth) {
  // console.log("push ", firstTooth.name, " away from ", secondTooth.name);
  const isLower = firstTooth.name.charAt(0) === "l";
  const FTX = getCenter(firstTooth).x;
  const STX = getCenter(secondTooth).x;
  const isFTPositive = FTX > 0;
  const isSTPositive = STX > 0;
  const firstToothIndex = firstTooth.parent.children.indexOf(firstTooth);
  const secondToothIndex = firstTooth.parent.children.indexOf(secondTooth);

  // console.log(FTX, STX, isLower);

  if (isFTPositive === isSTPositive) {
    if (isFTPositive) {
      if (firstToothIndex < secondToothIndex) {
        return isLower ? moveToothDistally : moveToothMesially;
      } else {
        return isLower ? moveToothMesially : moveToothDistally;
      }
    } else {
      if (firstToothIndex < secondToothIndex) {
        return isLower ? moveToothMesially : moveToothDistally;
      } else {
        return isLower ? moveToothDistally : moveToothMesially;
      }
    }
  } else {
    return moveToothDistally;
  }
}
function pullFirstCloserFromSecond(firstTooth, secondTooth) {
  // console.log("pull ", firstTooth.name, " closer to ", secondTooth.name);
  const isLower = firstTooth.name.charAt(0) === "l";
  const FTX = getCenter(firstTooth).x;
  const STX = getCenter(secondTooth).x;
  const isFTPositive = FTX > 0;
  const isSTPositive = STX > 0;
  const firstToothIndex = firstTooth.parent.children.indexOf(firstTooth);
  const secondToothIndex = firstTooth.parent.children.indexOf(secondTooth);

  if (isFTPositive === isSTPositive) {
    if (isFTPositive) {
      if (firstToothIndex < secondToothIndex) {
        return isLower ? moveToothMesially : moveToothDistally;
      } else {
        return isLower ? moveToothDistally : moveToothMesially;
      }
    } else {
      if (firstToothIndex < secondToothIndex) {
        return isLower ? moveToothDistally : moveToothMesially;
      } else {
        return isLower ? moveToothMesially : moveToothDistally;
      }
    }
  } else {
    return moveToothMesially;
  }
}
export function getCenter(mesh) {
  // let box3 = new Box3().setFromObject(mesh);
  const geometry = mesh.geometry;
  if (!geometry.boundingBox) {
    geometry.computeBoundingBox({ indirect: true });
  }
  const center = new Vector3();
  geometry.boundingBox.getCenter(center);
  mesh.localToWorld(center);
  // box3.getCenter(center);
  return center;
}
function getIndexShiftOffset(selectedTooth, call) {
  const center = getCenter(selectedTooth);
  if (call.name === "MoveToothDistally") {
    if (center.x > 0) {
      return 0;
    } else {
      return 1;
    }
  }
  return 0;
}
